import { useEffect } from 'react';

interface IProps {
  ref: React.RefObject<HTMLElement>;
  shouldListen?: boolean;
  onClickAway: (event: MouseEvent | TouchEvent) => void;
  ignoreEls?: (HTMLElement | null)[];
}

// takes a ref and calls the provided onClickAway callback when a click/touch event occurs outside of the ref element
const useOnClickAway = ({
  ref,
  shouldListen,
  onClickAway,
  ignoreEls,
}: IProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent): void => {
      // ignore 'away' clicks on the provided ignore elements
      const ignoreClick = ignoreEls?.some(
        (el) => el === event.target || el?.contains(event.target as Node)
      );

      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        !ignoreClick
      ) {
        onClickAway(event);
      }
    };

    if (shouldListen) {
      document.addEventListener('pointerdown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, [shouldListen, onClickAway]);
};

export default useOnClickAway;
